/**
 * Declare all Handlebar helpers.
 */

Handlebars.registerHelper('ifCond', function (v1, operator, v2, options) {

	switch (operator) {
		case '==':
			return (v1 == v2) ? options.fn(this) : options.inverse(this);
		case '===':
			return (v1 === v2) ? options.fn(this) : options.inverse(this);
		case '!==':
			return (v1 !== v2) ? options.fn(this) : options.inverse(this);
		case '<':
			return (v1 < v2) ? options.fn(this) : options.inverse(this);
		case '<=':
			return (v1 <= v2) ? options.fn(this) : options.inverse(this);
		case '>':
			return (v1 > v2) ? options.fn(this) : options.inverse(this);
		case '>=':
			return (v1 >= v2) ? options.fn(this) : options.inverse(this);
		case '&&':
			return (v1 && v2) ? options.fn(this) : options.inverse(this);
		case '||':
			return (v1 || v2) ? options.fn(this) : options.inverse(this);
		default:
			return options.inverse(this);
	}
});

Handlebars.registerHelper('select', function (selected, options) {
	return options.fn(this).replace(
		new RegExp(' value=\"' + selected + '\"'),
		'$& selected="selected"');
});

Handlebars.registerHelper("debug", function (optionalValue) {
	console.log("Current Context");
	console.log("====================");
	console.log(this);

	if (optionalValue) {
		console.log("Value");
		console.log("====================");
		console.log(optionalValue);
	}
});

Handlebars.registerHelper('capitalizeFirstLetter', function (str) {
	if (!str || str.length === 0) {
		return '';
	}
	return str.charAt(0).toUpperCase() + str.slice(1);
});

Handlebars.registerHelper('timestampFormat', function (context, block) {
	var inputFormat;
	if (moment && context) {
		if (moment(context, g_timeStampFormat, true).isValid()) {
			inputFormat = g_timeStampFormat;
		}
		return inputFormat ? moment(context, inputFormat).format(g_timeStampFormat) : moment(context).format(g_timeStampFormat);
	} else {
		return context;  //moment plugin not available. return data as is.
	}
});

Handlebars.registerHelper('dateFormat', function (context, block) {
	if (moment && context) {
		var f = block.hash.format || g_dateFormat;
		return moment(context).format(f);
	} else {
		return context;   //  moment plugin not available. return data as is.
	}
});


Handlebars.registerHelper('round', function (context, block) {
	if(context){
		return +(Math.round(context + "e+2")  + "e-2"); //https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/round see Decimal rounding.
	}
});

Handlebars.registerHelper('disableSelect500mZone', function(eventType, options) {
	if(eventType) {
        return eventType.inside_500m_zone ? options.fn(this) : options.inverse(this);
    }
    else {
        return options.inverse(this);
	}

});

Handlebars.registerHelper('is500MZoneChecked', function(eventType, logEntry, options) {
    if(eventType) {
        return eventType.inside_500m_zone === 'yes' || logEntry.inside_500m_zone === 'yes' ? options.fn(this) : options.inverse(this);
    }
    else {
        return options.inverse(this);
    }
});
